var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmSignupEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44585 27.0356C2.61976 27.0356 1.91258 26.7415 1.32431 26.1532C0.736032 25.5649 0.441895 24.8577 0.441895 24.0316V6.00791C0.441895 5.18182 0.736032 4.47464 1.32431 3.88637C1.91258 3.29809 2.61976 3.00396 3.44585 3.00396H18.6158C18.5157 3.50461 18.4656 4.00527 18.4656 4.50593C18.4656 5.00659 18.5157 5.50725 18.6158 6.00791H3.44585L15.4617 13.5178L20.9439 10.1008C21.2944 10.4262 21.6761 10.7078 22.0891 10.9457C22.5022 11.1835 22.934 11.39 23.3846 11.5652L15.4617 16.5218L3.44585 9.01187V24.0316H27.4775V11.8656C28.0533 11.7405 28.5915 11.5652 29.0921 11.3399C29.5928 11.1146 30.0559 10.8393 30.4814 10.5138V24.0316C30.4814 24.8577 30.1873 25.5649 29.599 26.1532C29.0108 26.7415 28.3036 27.0356 27.4775 27.0356H3.44585ZM25.9755 9.01187C24.7239 9.01187 23.66 8.57379 22.7838 7.69764C21.9077 6.82148 21.4696 5.75758 21.4696 4.50593C21.4696 3.25428 21.9077 2.19038 22.7838 1.31423C23.66 0.438077 24.7239 0 25.9755 0C27.2272 0 28.2911 0.438077 29.1672 1.31423C30.0434 2.19038 30.4814 3.25428 30.4814 4.50593C30.4814 5.75758 30.0434 6.82148 29.1672 7.69764C28.2911 8.57379 27.2272 9.01187 25.9755 9.01187Z",
    fill: "#9D1C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmSignupEmail);
export default __webpack_public_path__ + "static/media/confirm-signup-email.015bebc6fe294769522a1f802f50cc98.svg";
export { ForwardRef as ReactComponent };